import React, {useState} from "react";
import {PATH} from "../../../../../config";
import {Button, Col} from "antd";
import {selectUser} from "../../../../../redux/features/userSlice";
import {useSelector} from "react-redux";

const Preview = () => {
    const selector = useSelector

    const [AvatarFile, setAvatarFile] = useState(PATH+'avatar.png')

    const AvatarOnError = () => {
        setAvatarFile(PATH+'avatar.png')
    }
    let GetUser = selector(selectUser);
    // PATH + 'metahut-owner.jpg'
    
    let Form = useSelector ((state) => state.event.formData)

    return (
        <>
            <span className="text-white text-base mb-2 text-center block">Preview</span>
            <div className="events-card">
                <div className="events-cover" style={{background: `url(${Form.cover_image_src}) center center / cover`}}>
                    {/* <span className="events-badge">Live</span> */}
                </div>
                <div className="events_details">
                    <div className="events_header">
                        <span className="events_date">{Form.start_date + ' ' + Form.start_time } {/* JUNE 19, 2023 - 10:00 */} PM</span>
                        <div className="events-price events-price_soto">
                            <img src={PATH + 'soto_icon.svg'} alt=""/>
                            <span>{Form.ticket_value}</span>
                        </div>
                    </div>
                    <h2 className="events-title">{Form.name}</h2>
                    <span className="events-author">by @{GetUser.username}</span>
                    <div className="events_action">
                        <div className="events-visitor">
                            {/* <div className="relative avatar_box user-box" style={{backgroundColor: GetUser && GetUser.bgcolor}}>
                                <img src={AvatarFile} onError={AvatarOnError} width="100%" height="100%" className="user-avatar"/>
                            </div> */}
                            {/* <div className="events-visitor_count">156</div> */}
                        </div>
                        <Button type="primary" className="events-btn"> Want to go </Button>
                    </div>
                    <div className="events-bottom">
                        <div className="events-pool">
                            <div className="events-reward">
                                {/*<i className="icon-cake"></i>*/}
                                <span>Reward:</span>
                            </div>
                            <div className="events-amount">
                                <img src={PATH + 'token.svg'} alt=""/>
                                <span>{Form.reward_value} METO</span>
                            </div>
                        </div>
                        <div className="events-share">
                            <i className="icon-share"></i>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Preview;